"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _toString2 = _interopRequireDefault(require("lodash/toString"));
var _text = require("@mmc/text");
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _backgroundImage = _interopRequireDefault(require("./background-image"));
var _header = _interopRequireDefault(require("../styles/header-500.css"));
var _commonI18n = require("@mmc/common-i18n");
var _reactRedux = require("react-redux");
var _header2 = _interopRequireDefault(require("./header-500.props/header-500.defaultProps"));
var _header3 = _interopRequireDefault(require("./header-500.props/header-500.propTypes"));
/**
 * ## Header500 - component
 *
 * The Component according to confluence.
 * https://mmc-mason.atlassian.net/wiki/spaces/MP/pages/102105144/500-Header
 */

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp,
  renderEmptyString = dataUtils.renderEmptyString;
var Header500 = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Header500, _React$Component);
  Header500.resourceType = function resourceType() {
    return 'Header500_1_0_0';
  };
  function Header500(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.renderTag = _this.renderTag.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderLogo = _this.renderLogo.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderHeadline = _this.renderHeadline.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderParagraph = _this.renderParagraph.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderLink = _this.renderLink.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getAlignment = _this.getAlignment.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getThemeKey = _this.getThemeKey.bind((0, _assertThisInitialized2["default"])(_this));
    _this.styles = _header["default"];
    _this.imageOpacity = 0.5;
    return _this;
  }
  var _proto = Header500.prototype;
  _proto.getAlignment = function getAlignment(textAlignment) {
    textAlignment = (0, _toString2["default"])(textAlignment);
    var themeAlignment;
    if (textAlignment.toLowerCase() === 'right') {
      themeAlignment = 'end';
    } else if (textAlignment.toLowerCase() === 'center') {
      themeAlignment = 'center';
    } else {
      themeAlignment = 'start';
    }
    return themeAlignment;
  };
  _proto.getThemeKey = function getThemeKey(componentTheme) {
    componentTheme = (0, _toString2["default"])(componentTheme);
    return componentTheme.toLowerCase() === 'light' ? 'light-theme' : 'dark-theme';
  };
  _proto.renderTag = function renderTag(tag, theme, themeAlignment, disclaimerData) {
    if ((0, _isEmpty2["default"])(tag)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"].tag + " " + _header["default"][themeAlignment + "-margin"]
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: renderEmptyString(tag),
      className: theme.labelMedium,
      disclaimerData: disclaimerData
    }));
  };
  _proto.renderLogo = function renderLogo(logo, theme, themeAlignment) {
    if ((0, _isEmpty2["default"])(logo.image)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"].logoWrapper + " " + _header["default"][themeAlignment + "-margin"]
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: handleNestedProp(logo, 'logo.image'),
      alt: handleNestedProp(logo, 'logo.altText')
    }));
  };
  _proto.renderHeadline = function renderHeadline(theme, mainHeading, themeAlignment, disclaimerData) {
    if ((0, _isEmpty2["default"])(mainHeading)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _header["default"].headline
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"][themeAlignment + "-margin"] + " " + _header["default"].headingMaxWidth
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: mainHeading,
      className: theme.headingOne + " " + theme.marginBottom20,
      tag: "h1",
      disclaimerData: disclaimerData
    })));
  };
  _proto.renderParagraph = function renderParagraph(theme, paragraph, themeAlignment, disclaimerData) {
    if ((0, _isEmpty2["default"])(paragraph)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.introCopy + " " + _header["default"].paragraph
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"][themeAlignment + "-margin"] + " " + _header["default"].paragraphMaxWidth
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        html: paragraph,
        format: "inherit",
        theme: theme
      }),
      disclaimerData: disclaimerData
    })));
  };
  _proto.renderPrice = function renderPrice(theme, config, price, themeAlignment, priceDisclaimerId, addPriceDisclaimer, disclaimerData) {
    if ((0, _isEmpty2["default"])(price)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"][themeAlignment + "-margin"] + " " + _header["default"].paragraphMaxWidth + " " + _header["default"].paragraph
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.headingSix + " " + _header["default"].fontMedium + " " + theme.mb4
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: handleNestedProp(price, 'price.value'),
        displayValue: handleNestedProp(price, 'price.displayValue'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    })));
  };
  _proto.renderLink = function renderLink(themes, link, mainHeading, themeAlignment) {
    if ((0, _isEmpty2["default"])(link) || !link.label || !link.url) {
      return '';
    }
    var url = link.url,
      label = link.label,
      priority = link.priority,
      openNewTab = link.openNewTab,
      icon = link.icon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"][themeAlignment + "-margin"] + " " + themes.marginTop40
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: themes,
      "data-section": mainHeading,
      data: {
        url: url,
        label: label,
        priority: priority,
        openNewTab: openNewTab,
        ctaTheme: themes,
        icon: icon
      }
    }));
  }

  /*
    eslint-disable max-statements
  */;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData,
      config = _this$props.config;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var mainHeading = componentData.mainHeading,
      textAlignment = componentData.textAlignment,
      sectionHeading = componentData.sectionHeading,
      logo = componentData.logo,
      image = componentData.image,
      link = componentData.link,
      paragraph = componentData.paragraph,
      componentTheme = componentData.theme,
      disclaimerData = componentData.disclaimerData,
      price = componentData.price,
      displayVehiclePrice = componentData.displayVehiclePrice,
      addPriceDisclaimer = componentData.addPriceDisclaimer,
      priceDisclaimerId = componentData.priceDisclaimerId;
    var themeAlignment = this.getAlignment(textAlignment);
    var renderedTag = this.renderTag(sectionHeading, theme, themeAlignment, disclaimerData);
    var renderedLogo = this.renderLogo(logo, theme, themeAlignment);
    var renderedHeadline = this.renderHeadline(theme, mainHeading, themeAlignment, disclaimerData);
    var renderedParagraph = this.renderParagraph(theme, paragraph, themeAlignment, disclaimerData);
    var renderedPrice = this.renderPrice(theme, config, price, themeAlignment, priceDisclaimerId, addPriceDisclaimer, disclaimerData);
    var renderedLink = this.renderLink(theme, link, mainHeading, themeAlignment);
    var hasImage = image && image.image;

    // Check there is anything to even render
    if ((0, _isEmpty2["default"])(renderedTag) && (0, _isEmpty2["default"])(renderedLogo) && (0, _isEmpty2["default"])(renderedHeadline) && (0, _isEmpty2["default"])(renderedParagraph) && (0, _isEmpty2["default"])(renderedLink)) {
      return '';
    }
    // Either headline or message is not empty so render the component
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _header["default"]['header-500'] + " " + (componentData.theme ? theme[componentTheme] : '') + " " + (hasImage ? _header["default"].hasImage : ''),
      automation: "header-500"
    }, /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
      data: componentData
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _header["default"]['header-500-contents'] + " " + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-10']
    }, renderedTag, renderedLogo, renderedHeadline, displayVehiclePrice && renderedPrice, renderedParagraph, renderedLink)));
  }
  /*
    eslint-enable max-statements
  */;
  return Header500;
}(_react["default"].Component);
Header500.displayName = 'Header500';
Header500.defaultProps = {
  data: _header2["default"],
  defaultData: _header2["default"],
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(Header500);
exports["default"] = _default;